import { useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom';
import ProductManagement from '../content/ProductManagement';
import StoreReplenishmentScreen from '../content/StoreReplenishment/StoreReplenishmentScreen';
import StoreReplenishmentJofemarScreen from '../content/StoreReplenishment/StoreReplenishmentJofemarScreen';
import StoreScreen from '../content/Stores/StoreScreen';
import UserManagementTable from '../content/UserManagement/UserManagementTable';
import OrdersTable from '../content/Orders/OrdersTable';
import StoreSupportScreen from '../content/StoreSupport/StoreSupportScreen';
import Dashboard from '../content/Dashboard/Dashboard';
import useAuthState from '../hooks/useAuthState';
import StoreOverviewScreen from '../content/StoreOverview/StoreOverviewScreen';
import StoreSupportJofemarScreen from '../content/StoreSupport/StoreSupportJofemarScreen';
import FinancialDashboard from '../content/FinancialDashboard/FinancialDashboard';
import TraceBlocksScreen from '../content/TraceBlocks/TraceBlocksScreen';
import CashModuleSettingsScreen from '../content/CashModule/CashModuleSettingsScreen';
import ReplenishmentAdvice from '../content/ReplenishmentAdvice/ReplenishmentAdvice';

function RoutesContainer() {
  const { User } = useAuthState();
  const [UserGroup, setUserGroup] = useState("")

  useEffect(() => {
    if (User.attributes?.["custom:role"]) {
      setUserGroup(User.attributes["custom:role"])
    }
  }, [User])

  return (
    <div id="tableContainer">
      <Switch>

        <Route
          exact
          path="/"
          component={StoreScreen}
        />

        {UserGroup !== "replenishmentuser" ?
          <Route
            path="/financial-dashboard"
            component={FinancialDashboard}
          /> : null}

        {UserGroup !== "replenishmentuser" ?
          <Route
            exact
            path="/dashboard"
            component={Dashboard}
          /> : null}

        <Route
          exact
          path="/retail-locations"
          component={StoreScreen}
        />

        {UserGroup !== "replenishmentuser" ?
          <Route
            exact
            path="/product-management"
            component={ProductManagement}
          /> : null}

        {UserGroup !== "replenishmentuser" ?
          <Route
            exact
            path="/orders"
            component={OrdersTable}
          /> : null}

        <Route
          exact
          path="/store-replenishment"
          component={StoreReplenishmentScreen}
        />
        <Route
          exact
          path="/store-replenishment-jofemar"
          component={StoreReplenishmentJofemarScreen}
        />
        <Route
          exact
          path="/store-support"
          component={StoreSupportScreen}
        />
        <Route
          exact
          path="/store-support-jofemar"
          component={StoreSupportJofemarScreen}
        />
        <Route
          exact
          path="/store-overview"
          component={StoreOverviewScreen}
        />
        <Route
          exact
          path="/trace-blocks"
          component={TraceBlocksScreen}
        />

        {UserGroup !== "replenishmentuser" ?
          <Route
            exact
            path="/user-management"
            component={UserManagementTable}
          /> : null}

        <Route
          path="/cash-module-settings"
          component={CashModuleSettingsScreen}
        />

        <Route
          exact
          path="/replenishment-advice"
          component={ReplenishmentAdvice}
        />

      </Switch>
    </div>
  )
}

export default RoutesContainer
